import React from "react";
import "../css/InputField.css";
import { MdOutlineArrowDropDown } from "react-icons/md";
import { IoIosSearch } from "react-icons/io";

const CuInput = ({
  placeholder,
  label,
  type = "text",
  dropdown = false,
  value,
  onChange,
  required,
  disabled,
  loading = false,
  search = false,
  position = "calc(50% - 0px)",
  onKeyDown = () => {},
  onFocus = () => {},
  onBlur = () => {},
  onClick = () => {},
  star,
}) => {
  return (
    <div className="custom-input-field">
      <label>
        {label} {star && <span className="text-red-500">*</span>}
      </label>
      <input
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
        onClick={onClick}
        className="text-sm"
      />
      {(loading || dropdown || search) && (
        <div className="cu-input-icon-container" style={{ top: position }}>
          {loading && <i className="cu-input-loader"></i>}
          {!loading && dropdown && <MdOutlineArrowDropDown size={21} />}
          {!loading && search && <IoIosSearch size={21} />}
        </div>
      )}
    </div>
  );
};

export default CuInput;
